import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { testimonials, stats } from '@/mocks/testimonials';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 国产精品视频精选推荐平台',
    description: '国产精品视频精选推荐平台致力于汇聚和推荐高品质国产原创视频内容，涵盖剧情、纪录、综艺、短片等多元类型。',
    about: {
      '@type': 'Organization',
      name: '国产精品视频精选推荐平台',
      description: '汇聚海量国产精品视频，涵盖剧情、纪录、综艺、短片等多元类型。精心筛选高品质国产原创内容。',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="关于我们 - 国产精品视频精选推荐平台"
        description="国产精品视频精选推荐平台致力于汇聚和推荐高品质国产原创视频内容。了解我们的品牌故事、用户口碑和联系方式，发现更多精彩视频。"
        keywords="国产精品视频,关于我们,国产视频平台,联系信息"
        canonicalPath="/about"
        schemaJson={[aboutSchema]}
      />

      <Navbar />

      <main className="pt-16">
        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-5xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />

            <section className="mt-8 mb-16">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-6">
                关于我们
              </h1>
              <div className="prose prose-sm max-w-none text-foreground-700 leading-relaxed">
                <p className="text-lg text-foreground-800">
                  国产精品视频精选推荐平台成立于2020年，是一家专注于国产原创视频内容精选与推荐的在线平台。我们致力于为观众提供高品质、多元化的国产视频内容，涵盖剧情片、纪录片、综艺节目和创意短片等丰富类型。
                </p>
                <p>
                  在内容为王的时代，我们坚持"品质优先、原创为本"的理念，与国内众多优秀导演、制作团队建立了深度合作关系。每一部上线的视频都经过专业的内容审核团队严格筛选，确保为观众呈现最具价值和观赏性的作品。
                </p>
                <p>
                  经过多年的发展，平台已积累了超过10,000部精选视频内容，涵盖社会人文、自然探索、艺术创作、娱乐综艺等多个领域。我们的用户遍布全国各地，日均播放量超过300万次，已成为国产精品视频领域最具影响力的平台之一。
                </p>
              </div>
            </section>

            <section className="mb-16">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
                {stats.map((stat) => (
                  <div key={stat.label} className="bg-background-100 rounded-lg p-6 text-center">
                    <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading mb-2">
                      {stat.value}
                    </div>
                    <div className="text-sm text-foreground-500">{stat.label}</div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                用户口碑
              </h2>
              <p className="text-foreground-500 text-sm mb-8">来自全国各地的真实用户评价</p>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {testimonials.map((t, index) => (
                  <div
                    key={index}
                    className="bg-background-50 rounded-lg p-6 border border-background-200/70"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <div>
                        <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                        <div className="text-xs text-foreground-500">{t.location}</div>
                      </div>
                    </div>
                    <div className="flex items-center gap-0.5 mb-3">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed">{t.content}</p>
                    <p className="text-xs text-foreground-400 mt-3">{t.date}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-8">
                联系我们
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-background-100 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-mail-line text-xl text-primary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">电子邮箱</h3>
                  <p className="text-sm text-foreground-500">contact@guochanjp.com</p>
                </div>
                <div className="bg-background-100 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-customer-service-2-line text-xl text-primary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">在线客服</h3>
                  <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
                </div>
                <div className="bg-background-100 rounded-lg p-6 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-map-pin-line text-xl text-primary-600"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">公司地址</h3>
                  <p className="text-sm text-foreground-500">北京市朝阳区传媒科技园</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}